import { FC, useEffect } from 'react';
import { messagesStore } from '../../store/messages';
import { IMessageModal } from '../../types/messages';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import { localeStore } from 'src/mobx/localesStore';
import { userStore } from 'src/mobx/userStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import Icon from 'src/view/components/Controls/Icon/Icon';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';

let logoutTimer: NodeJS.Timeout | null = null;

interface IProps {
  data?: IMessageModal;
}

const BranchAccessMessage: FC<IProps> = ({ data }: IProps): JSX.Element => {
  const { id } = data || {};

  useEffect(() => {
    if (userStore.isLogin) {
      logoutTimer = setTimeout(onClose, 10000);
    }

    return () => {
      if (logoutTimer) clearTimeout(logoutTimer);
    };
  }, []);

  const onClose = () => {
    if (id) {
      messagesStore.removeMessage(id);
      if (userStore.isLogin) userStore.logout();
      if (logoutTimer) clearTimeout(logoutTimer);
    }
  };

  return (
    <>
      <div className="branch-access-message__backdrop" onClick={onClose}></div>
      <ModalBackground className="branch-access-message__wrapper">
        <Icon size={90} color={theme.colors.red} name={Icons.Warning} />
        <Text type={TEXT.MODAL_MESSAGE} text="branch_access_error" className="mt-8 mb-8" />
        <Button title={localeStore.t(userStore.isLogin ? 'logout_button' : 'close')} onClick={onClose} size="large" appearance="tertiary" />
      </ModalBackground>
    </>
  );
};

export default BranchAccessMessage;
